import type { paths } from '@schuelerhilfe/shared-components/src/types/schema';
import createFetchClient from 'openapi-fetch';
import { ClientEnvironment } from '@/lib/env.client';

// This module is bundled into the browser, so it may only read public env
// values (`env.client.ts`).
//
// Server: API_URL — the real (internal) backend host, read at runtime.
// Browser: NEXT_PUBLIC_API_URL — the public backend URL (through Cloudflare
// in production, localhost in local dev). Calls go directly to the backend;
// there are no same-app proxy routes.
export const fetchClient = createFetchClient<paths>({
  baseUrl:
    typeof window === 'undefined'
      ? ClientEnvironment.API_URL
      : ClientEnvironment.NEXT_PUBLIC_API_URL,
});
